import { AfterViewInit, Component, inject } from '@angular/core';
import { Router, RouterModule, RoutesRecognized } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { filter, fromEvent, pairwise, timer, Unsubscribable } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { AppState } from './shared/common/utils/AppState';
import { UtilComponent } from './shared/common/utils/UtilComponent';
import { bootstrapAppAt } from 'lowcoder-sdk';
import { CandidateStore } from './modules/manage/workflow/recruit/candidate/store/candidate.store';
import { PostStore } from './modules/manage/workflow/task/service/post.store';
// import { SwUpdate } from '@angular/service-worker';
import 'ag-grid-enterprise';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    isShowUnlockSession: boolean = false;
    countInterval: any;
    countIdle = 0;
    private _unsubscribableArray: Array<Unsubscribable> = [];
    candidateStore = inject(CandidateStore);
    postStore = inject(PostStore);

    isLoading$ = this._appState.loading$; // Use the observable

    constructor(
        private _router: Router,
        // private swUpdate: SwUpdate,
        private _appState: AppState,
        private _translateService: TranslocoService,
        private _utilComp: UtilComponent
    ) {
        this._router.events
            .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
            .subscribe((events: RoutesRecognized[]) => {
                localStorage.setItem('PREVIORS_URL', events[0].urlAfterRedirects);
                localStorage.setItem('CURRENT_URL', events[1].urlAfterRedirects);
            });
    }

    ngAfterViewInit(): void {
        // this.#registerServiceWorkerUpgrade();
        setTimeout(() => {
            this.startUserIdle();
        }, 10000);

        // if (environment.production) {
            // apply monkey patching technique for ag-grid
            const consoleError = console.error;
            console.error = function () {
                const msgs = [];
                while (arguments.length) {
                    const err = arguments[0];
                    if (err && (typeof err === 'string' || err instanceof String)) {
                        if (
                            err.indexOf('*******************************************') > -1 ||
                            err.indexOf('ag-Grid Enterprise') > -1 ||
                            err.indexOf('ag-Grid') > -1 ||
                            err.indexOf('AG Grid Enterprise License') > -1 ||
                            err.indexOf('Invalid License') > -1 ||
                            err.indexOf('License Key Not Found') > -1 ||
                            err.indexOf('All AG Grid Enterprise features are unlocked') > -1 ||
                            err.indexOf('it is not licensed for development projects intended') > -1 ||
                            err.indexOf('info@ag-grid.com') > -1 ||
                            err.indexOf('are trying to use was released on') > -1 ||
                            err.indexOf('                                                                                                                          ') > -1
                        ) {
                            break;
                        }
                    }
                    msgs.push([].shift.call(arguments));
                }
                consoleError.apply(console, msgs);
            };
        // }
    }

    loadLowcoder(): void {
        try {
            const node = document.querySelector('#lowcoderEmpty');
            const lowcoderFormKey = this._appState.getLowcoderFormKey();
            const appId = lowcoderFormKey['EMPTY'];
            bootstrapAppAt(appId, node, {
                baseUrl: window['HOST_NAME_LOWCODER'],
            });
        } catch (error) {
            console.log(error);
        }
    }

    startUserIdle() {
        if (window['isMobile']) {
            return;
        }

        this._unsubscribableArray.push(
            fromEvent(window, 'click').subscribe(() => {
                if (window['isMobile'] || this.isShowUnlockSession) {
                    return;
                }

                let hash: string = location.hash;
                hash = hash.toString().replace('#', '');
                if (this._appState.checkRoutePassLogin(hash)) {
                    return;
                }

                // Reset idle counter and clear existing interval
                this.countIdle = 0;
                if (this.countInterval) {
                    clearInterval(this.countInterval);
                    this.countInterval = null;
                }

                // Only start a new interval if none is running
                if (!this.countInterval) {
                    this.setCountInterVal();
                }
            })
        );

        // Start the interval initially if not already running
        if (!this.countInterval) {
            this.setCountInterVal();
        }
    }

    setCountInterVal(): void {
        try {
            // Ensure no duplicate intervals are created
            if (this.countInterval) {
                clearInterval(this.countInterval);
            }

            this.countInterval = setInterval(() => {
                if (this.isShowUnlockSession) return;

                let hash: string = location.hash;
                hash = hash.toString().replace('#', '');
                if (this._appState.checkRoutePassLogin(hash)) {
                    return;
                }

                this.countIdle++;
                if (this.countIdle >= window['SESSION_TIME_OUT'] && !this.isShowUnlockSession) {
                    this.countIdle = 0;
                    this.isShowUnlockSession = true;
                    this._utilComp.openConfirmationDialogCancel(
                        this._translateService.translate('GENERAL.UNLOCK_YOUR_SESSION_2'),
                        () => {
                            this._router.navigate(['/unlock-session']);
                            this.isShowUnlockSession = false; // Reset state after navigation
                        },
                        '',
                        this._translateService.translate('CONTROL.CLOSE'),
                        false
                    );
                }
            }, 60000);
        } catch (error) {
            console.log(error);
        }
    }

    // #registerServiceWorkerUpgrade() {
    //     if (this.swUpdate.isEnabled) {
    //         timer(0, 60000).subscribe(() => {
    //             this.swUpdate.checkForUpdate().then((res) => {
    //                 if (res) {
    //                     if (confirm('A new version is available, do you want to load it?')) {
    //                         window.location.reload();
    //                     }
    //                 }
    //             });
    //         });
    //     }
    // }
}